module.exports = __webpack_public_path__ + "img/redeem.cf5adaca.gif";